import { mergeStyles } from 'app/theme/materialTheme';
import { Close } from 'common/components/icons/Close';
import { useBreakpoint } from 'common/hooks/useMediaQuery';
import { useTranslation } from 'common/hooks/useTranslation';
import { Lambda } from 'common/types';
import { FC, PropsWithChildren } from 'react';

import { Dialog, DialogContent, IconButton, Toolbar, Typography } from '@mui/material';

import { OutletTypes } from 'app/outlets/components/OutletMenu/OutletMenu';
import { AvailableOutletTypes } from 'app/outlets/AvailiableOutletTypes';
import * as styles from '../../../outlets/components/PremiseOutlets/components/styles';

export const AddFiberDialog: FC<
  PropsWithChildren<{ isOpen: boolean; onClose: Lambda<void, void>; outletType: OutletTypes }>
> = ({ isOpen, onClose, children, outletType }) => {
  const { t } = useTranslation();
  const { isTabletUp } = useBreakpoint();

  return (
    <Dialog open={isOpen} PaperProps={{ sx: styles.dialog }} fullScreen={!isTabletUp}>
      <Toolbar sx={mergeStyles([styles.dialogTopbar, isTabletUp ? {} : styles.smallDialogTopbar])}>
        <Typography>
          {outletType === AvailableOutletTypes.OUTLET ? t('fiber.add.dialog.header') : t('tp.add.dialog.header')}
        </Typography>
        <IconButton size={isTabletUp ? 'large' : 'small'} color="inherit" onClick={() => onClose()}>
          <Close />
        </IconButton>
      </Toolbar>

      <DialogContent sx={styles.dialogContent}>{children}</DialogContent>
    </Dialog>
  );
};
